import { jsx as _jsx } from "react/jsx-runtime";
const TuxInputGroupAddon = (props) => {
    const { addonType, children } = props;
    return _jsx("div", Object.assign({ className: `input-group-${addonType}` }, { children: children }), void 0);
};
export default TuxInputGroupAddon;
